import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const LABEL_PREFIX = 'account.signup';
const SignUpUsp = ()=>{
    const { getLabel , getFormattedLabel , hasLabel  } = useIntl();
    const labels = {
        noAccountYet: getLabel(`${LABEL_PREFIX}.usp.noAccountYet`),
        createAnAccount: getLabel(`${LABEL_PREFIX}.usp.createAnAccount`, {
            hideLabelKey: true
        }),
        usps: Array(5).fill(0).map((_, index)=>{
            const labelKey = `${LABEL_PREFIX}.list.usp${index + 1}`;
            return hasLabel(labelKey) ? getFormattedLabel(labelKey, {
                parseLink: true,
                parseHTML: true,
                hideLabelKey: true
            }) : undefined;
        }).filter((usp)=>usp !== undefined
        ),
        footer: getFormattedLabel(`${LABEL_PREFIX}.usp.footer`, {
            parseHTML: true,
            parseLink: true,
            hideLabelKey: true
        })
    };
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "small"
    }, labels.noAccountYet), labels.createAnAccount && /*#__PURE__*/ React.createElement(Text, null, labels.createAnAccount), /*#__PURE__*/ React.createElement("ul", {
        className: "checkmark-list"
    }, labels.usps.map((usp, idx)=>/*#__PURE__*/ React.createElement("li", {
            key: idx
        }, /*#__PURE__*/ React.createElement(Text, null, usp))
    )), labels.footer && /*#__PURE__*/ React.createElement(Text, null, labels.footer));
};

export { SignUpUsp };
//# sourceMappingURL=SignUpUsp.js.map
